(function(){
    'use strict'

    angular
    .module('app.centrosCosto')
    .controller('EditarCentroCosto', EditarCentroCosto);

    EditarCentroCosto.$inject = ['$scope', '$animationsSrv', '$routeParams', 'CentrosCostoService', 'logger', '$location', 'UserInfoService'];

    function EditarCentroCosto($scope, $animationsSrv, $routeParams, CentrosCostoService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;
        vm.centroCosto = {};

        vm.centroCostoId = $routeParams.id ? $routeParams.id : 0;

        getCentroCosto();

        function getCentroCosto(){

            if(vm.centroCostoId != 0){
                var promise = CentrosCostoService.getById(UserInfoService.getCompaniaId(), vm.centroCostoId);

                promise
                .then(function(centroCosto){
                    vm.centroCosto = centroCosto;
                })
                .catch(function(error){
                    switch (error.status) {
                        case 401:
                            logger.error('La sesión ha expirado');
                            break;
                    
                        default:
                            logger.error('Hubo un error al obtener el centro de costo: ' + error.data.Message);
                            break;
                    }
                });               
            }

        };

        vm.save = function(){

            $scope.submitted = true;

            if($scope.centroCostoForm.$valid){
                if(!vm.centroCosto.id){
                    saveCentroCosto();
                }
                else if($scope.centroCostoForm.$dirty){
                    updateCentroCosto();
                }
                else{
                    logger.info('No has modificado ningún dato!');
                }
            }     
        
        };

        function saveCentroCosto() {
            var promise = CentrosCostoService.save(vm.centroCosto);
            
            promise
            .then(function(response){
                logger.success('Centro de Costo creado con éxito.');
                clearCentroCostoData();
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al crear el centro de costo: ' + error.data.Message);
                        break;
                }
            });   
        };

        function updateCentroCosto(){
            var promise = CentrosCostoService.update(vm.centroCosto);
            
            promise
            .then(function(response){
                logger.success('Centro de Costo modificado con éxito.');
                $location.path('/centros-costo');
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sesión ha expirado');
                        break;
                
                    default:
                        logger.error('Hubo un error al modificar el centro de costo: ' + error.data.Message);
                        break;
                }
            });   
        };

        function clearCentroCostoData(){
            $scope.submitted = false;
            // Reset the form model.
            vm.centroCosto = {};
            // Set back to pristine.
            $scope.centroCostoForm.$setPristine();
            // Since Angular 1.3, set back to untouched state.
            $scope.centroCostoForm.$setUntouched();
        };

    }
})();